import {useState} from "react";

function Task() {
    const [tasks, setTasks] = useState([
        {
            id: 1,
            name: "AAAA",
            complete: true
        },
        {
            id: 2,
            name: "BBBBB",
            complete: false
        },
    ]);
    const [newTask, setNewTask] = useState('')
    const [Edit, setEdit] = useState(0)
    const [EditTaskinput, setEditTaskinput] = useState('')

    function AddTask(event) {
        event.preventDefault();
        console.log(newTask)
        let length = parseInt(Math.random() * 100000)

        // console.log(length)
        setTasks([...tasks, {id: length, name: newTask, complete: false}])
        setNewTask('')
    }

    function DeletTask(id) {
        console.log(id)

        const fTasks = tasks.filter((t) => {
            return t.id !== id
        })
        console.log(tasks)
        setTasks(fTasks)
    }

    function Changecomplete(id) {
        console.log(id)
      let mTask=  tasks.map((t) => {
            if (t.id === id)
                return {...t, complete: !t.complete}
            else return t

        })
        setTasks(mTask)
        console.log(tasks)

    }

    function EditTask(id) {
        console.log(id)
        setEdit(id)
    }
    function SaveTask(id) {
        console.log(id)

        let mTask=  tasks.map((t) => {
            if (t.id === id)
                return {...t, name: EditTaskinput}
            else return t

        })
        setTasks(mTask)
        setEdit(0)

    }
    function CanselTask(id) {
        setEdit(0)
    }

    return (
        <div className="container">
            <div>Task</div>
            <div className='row'>
                <div className="col-4 m-auto mt-5 border border-2 rounded-2 p-3">

                    <div>
                        <form onSubmit={(event) => AddTask(event)}>
                            <input onChange={(event) => setNewTask(event.target.value)} type="text" value={newTask}
                                   className='form-control-sm w-75' placeholder='وظیفه خود را وارد کنید.'></input>
                            <button type="submit" className='btn btn-sm me-4  btn-success'>send</button>
                        </form>
                    </div>
                    <div className='my-3'>
                        <ul className='list-group p-0'>

                            {tasks.map((t, index) =>
                                (<li className='list-group-item' key={t.id}  >
                                    {Edit!==t.id ? <div><div className='float-end'>
                                            <input type="checkbox" name={t.name} id={t.id} checked={t.complete}
                                                   onChange={() => Changecomplete(t.id)}></input>
                                            <label htmlFor={t.id}
                                                   className={t.complete ? 'text-decoration-line-through' : ''}
                                            > {t.name} </label>
                                        </div>

                                        <div className='float-start'>
                                            <button onClick={() => EditTask(t.id)}
                                                    className=' btn btn-link text-info btn-sm text-decoration-none'> ویرایش
                                            </button>
                                            <button onClick={() => DeletTask(t.id)}
                                                    className=' btn btn-link text-danger btn-sm text-decoration-none'>
                                                حذف
                                            </button>
                                        </div></div> :
                                        <div>
                                            <input className='form-control-sm w-50'
                                                   onChange={(event) => setEditTaskinput(event.target.value)}
                                                   type='text' defaultValue={t.name}></input>
                                            <button onClick={() => SaveTask(t.id)}
                                                    className=' btn btn-link text-success btn-sm   text-decoration-none'>
                                                ذخیره
                                            </button>
                                            <button onClick={() => CanselTask(t.id)}
                                                    className=' btn btn-link text-warning  btn-sm  text-decoration-none'>
                                                انصراف
                                            </button>
                                        </div>

                                    }


                                </li>)
                            )}

                            {/* <li className='list-group-item'>

                                <input type="checkbox" name="task" id="task"></input>
                                <label htmlFor="task">sdsddfdsf</label>
                                <div className='float-start'>
                                    <button className=' btn btn-link text-info btn-sm text-decoration-none'> ویرایش
                                    </button>
                                    <button className=' btn btn-link text-danger btn-sm text-decoration-none'> حذف
                                    </button>
                                </div>

                            </li>*/}


                        </ul>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default Task
